<!--
  ~ Copyright (c) 2021 Signum+ Software & Facility GmbH
  ~ Author: sebastian.woess@signum-plus.at
  -->

<ng-container *ngIf="labelModel && model.labelPosition === 'left'" [kitComponent]="labelModel"
  kitComponentClass="kit-checkbox-label" [kitComponentAttributes]="{ for: id }"></ng-container>

<input [kitCheckboxInput]="model" [id]="id">

<ng-container *ngIf="labelModel && model.labelPosition === 'right'" [kitComponent]="labelModel"
  kitComponentClass="kit-checkbox-label" [kitComponentAttributes]="{ for: id }"></ng-container>
